import React from 'react';
import IndustryPageTemplate from '@/components/IndustryPageTemplate';
import { solutionsAds } from '@/config/ads';

const Brands: React.FC = () => {
  return (
    <IndustryPageTemplate
      slug="brands"
      industry="Brands"
      heroHeadline="Interactive ads help brands stand out, engage audiences, and drive measurable results."
      heroSubheadline="High-impact formats capture attention and increase engagement beyond static ads, helping your brand break through the noise."
      section2Title="High-impact formats capture attention and increase engagement beyond static ads."
      section2Content="In today's crowded digital landscape, static banners simply don't cut it. Interactive creative commands attention, invites exploration, and creates memorable brand experiences that resonate with audiences long after they've scrolled past."
      section3Title="Interactive creative drives stronger performance across awareness, consideration, and conversion."
      section3Content="From building brand awareness to driving conversions, interactive ads deliver results at every stage of the funnel. Engaging formats encourage deeper interaction, leading to higher recall, stronger purchase intent, and better ROI on your media spend."
      section4Title="Ideal for marketing teams looking to differentiate, perform better, and maximize media investment."
      section4Content="Real-time creative updates allow brands to optimize campaigns without rebuilding or relaunching. Test messaging, swap creative assets, and respond to market conditions instantly—all while your campaign is live."
      heroImage="https://d64gsuwffb70l.cloudfront.net/69408eb499b5789ef7367cf9_1765908347924_20333f62.jpg"
      heroAd={solutionsAds.brand1}
      section2Ad={solutionsAds.brand2}
      section3Ad={solutionsAds.brand3}
      accentColor="bg-blue-100 text-blue-700"
      stats={[
        { value: '3x', label: 'Higher engagement' },
        { value: '+85%', label: 'Brand recall' },
        { value: '2.5x', label: 'Conversion lift' },
        { value: '40%', label: 'Lower CPA' },
      ]}
      benefits={[
        'Brand marketing teams driving awareness',
        'Performance marketers optimizing ROI',
        'Creative directors elevating campaigns',
        'Media teams maximizing investment',
      ]}
    />
  );
};

export default Brands;
